import type { IconProps } from '../../types/icon-props';

export const NoComment = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame">
        <g id="Group">
          <g id="Vector">
            <path
              d="M110.569 101.16L118.156 2.34375L8.66352 59.3123L42.0741 74.3004L53.0757 103.917L74.4481 83.0564L110.569 101.16ZM118.156 2.34375L74.4481 83.0564L118.156 2.34375ZM118.156 2.34375L42.0741 74.3004L118.156 2.34375ZM30.1489 96.4964L17.3666 111.465L30.1489 96.4964ZM72.7142 117.656L78.3678 111.033L72.7142 117.656ZM84.9184 103.359L86.6722 101.313L84.9184 103.359ZM16.802 76.0409L11.1484 82.658L16.802 76.0409ZM4.59102 90.3312L2.84375 92.3775L4.59102 90.3312Z"
              fill="white"
            />
            <path
              d="M118.156 2.34375L110.569 101.16L74.4481 83.0564M118.156 2.34375L8.66352 59.3123L42.0741 74.3004M118.156 2.34375L74.4481 83.0564M118.156 2.34375L42.0741 74.3004M42.0741 74.3004L53.0757 103.917L74.4481 83.0564M30.1489 96.4964L17.3666 111.465M72.7142 117.656L78.3678 111.033M84.9184 103.359L86.6722 101.313M16.802 76.0409L11.1484 82.658M4.59102 90.3312L2.84375 92.3775"
              stroke="#686869"
              strokeWidth="3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            id="Vector_2"
            d="M41.5781 72.923L51.732 63.2307L27.2704 51.2307L11.5781 59.0769L41.5781 72.923ZM109.424 99.2307L110.347 86.3076L81.732 72.4615L76.3377 82.3172L109.424 99.2307Z"
            fill="#CCE7FE"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};

NoComment.displayName = 'NoComment';
